import { useState } from 'react';
import { X } from 'lucide-react';
import { Dialog, DialogContent, DialogClose } from '../components/ui/dialog';

const galleryImages = [
  {
    src: 'https://5.imimg.com/data5/SELLER/Default/2025/2/491612029/KN/FF/BP/116025110/dc-1000x1000.jpeg',
    alt: 'Our Warehouse',
    title: 'Store Interior',
  },
  {
    src: 'https://5.imimg.com/data5/SELLER/Default/2025/2/491612240/HA/GP/LO/116025110/nhg-1000x1000.jpeg',
    alt: 'Warehouse Unit',
    title: 'Our Storage Facility',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_unlock-it-2/artifacts/8jeizxwq_IMG_1558.jpeg',
    alt: 'Aggarwal Foam Palace Store',
    title: 'Our Store Front',
  },
  {
    src: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&q=80',
    alt: 'Premium Mattresses',
    title: 'Premium Mattress Collection',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_unlock-it-2/artifacts/2zrfb1go_IMG_1519.jpeg',
    alt: 'Adjustable Mattress',
    title: 'Modern Adjustable Bed',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_unlock-it-2/artifacts/2bn8m45h_IMG_1518.jpeg',
    alt: 'Eclipse Mattress',
    title: 'Eclipse Premium Mattress',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_unlock-it-2/artifacts/iw4ujk8b_IMG_1512.webp',
    alt: 'Harmony Ortho',
    title: 'Eclipse Harmony Ortho Collection',
  },
  {
    src: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&q=80',
    alt: 'Blankets',
    title: 'Cozy Blankets',
  },
];

export const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <main data-testid="gallery-page" className="bg-[#FDFBF7]">
      {/* Hero Section */}
      <section className="py-12 md:py-20 bg-gradient-to-br from-[#FDFBF7] via-[#F0FDFA] to-[#CCFBF1]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm font-medium tracking-widest uppercase text-teal-700 mb-3">
            Take a Look
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-stone-800 mb-6">
            Our Gallery
          </h1>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Explore our store, products, and the quality we offer. See why families trust us for their home furnishing needs.
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-12 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {galleryImages.map((image, index) => (
              <div 
                key={index}
                data-testid={`gallery-image-${index}`}
                onClick={() => setSelectedImage(image)}
                className="group relative overflow-hidden rounded-2xl cursor-pointer aspect-square shadow-lg hover:shadow-2xl transition-shadow"
              >
                <img 
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <p className="text-white font-semibold">{image.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Additional Info */}
          <div className="mt-12 text-center">
            <p className="text-stone-600 mb-4">
              Want to see more? Visit our store at Yusuf Sarai Market, New Delhi
            </p>
            <a 
              href="https://maps.app.goo.gl/tLGnG1nKfKTFJZHaA"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="gallery-directions-link"
              className="text-teal-600 hover:text-teal-700 font-semibold"
            >
              Get Directions →
            </a>
          </div>
        </div>
      </section>

      {/* Lightbox Dialog */}
      <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
        <DialogContent className="max-w-4xl p-0 bg-black border-none">
          <DialogClose className="absolute top-4 right-4 z-10 bg-white/20 hover:bg-white/30 rounded-full p-2">
            <X className="w-6 h-6 text-white" />
          </DialogClose>
          {selectedImage && (
            <div className="relative">
              <img 
                src={selectedImage.src}
                alt={selectedImage.alt}
                className="w-full h-auto max-h-[80vh] object-contain"
                data-testid="lightbox-image"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <p className="text-white text-xl font-semibold">{selectedImage.title}</p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </main>
  );
};

export default GalleryPage;
